import { useState } from 'react';
import axios from 'axios';
import { API } from '../App';
import { toast } from 'sonner';
import { RefreshCw, Loader2 } from 'lucide-react';

const estadoCls = (estado, ok) => {
  if (ok) return 'bg-emerald-100 text-emerald-700';
  if (estado === 'Rechazado') return 'bg-red-100 text-red-700';
  return 'bg-amber-100 text-amber-800';
};

export const EcfStatus = ({ invoice, onUpdated, canResend = true }) => {
  const [sending, setSending] = useState(false);
  if (!String(invoice?.ncf || '').startsWith('E') || ['pendiente', 'anulada'].includes(invoice.status)) return null;

  const ok = Boolean(invoice.ecf_qr);
  const estado = invoice.ecf_estado || 'Pendiente de envío';

  const reenviar = async () => {
    setSending(true);
    try {
      const { data } = await axios.post(`${API}/invoices/${invoice.id}/ecf/enviar`);
      if (data.ecf_qr) toast.success(`e-CF ${invoice.ncf}: ${data.ecf_estado}`);
      else toast.error(`e-CF ${invoice.ncf}: ${data.ecf_error || data.ecf_estado}`);
      onUpdated?.();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Error reenviando e-CF');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="flex items-center gap-1 mt-1" data-testid={`ecf-status-${invoice.numero_factura}`}>
      <span className={`px-1.5 py-0.5 text-[10px] font-semibold rounded ${estadoCls(estado, ok)}`} title={invoice.ecf_error || invoice.ecf_track_id || ''}>
        e-CF: {estado}
      </span>
      {!ok && canResend && (
        <button
          type="button"
          onClick={reenviar}
          disabled={sending}
          className="text-blue-600 hover:text-blue-800 disabled:opacity-50"
          title="Reenviar e-CF"
          data-testid={`resend-ecf-btn-${invoice.numero_factura}`}
        >
          {sending ? <Loader2 size={13} className="animate-spin" /> : <RefreshCw size={13} />}
        </button>
      )}
    </div>
  );
};
